import React from 'react';
import { View } from 'react-native';

import { Shimmer } from '@vfgroup-oneplatform/foundation/Components';
import { shimmerPlaceholderConfig } from '@vfgroup-oneplatform/foundation/Components/Shimmer/Shimmer.utils';
import { useTheme } from '@vfgroup-oneplatform/foundation/Components/Themes';

import styles from './ExtraLoadingScreen.styles';
import {
  titleLoadingConfig,
  tabLoadingConfig,
  optionTitleLoadingConfig,
  optionsLoadingConfig,
  footerLoadingConfig,
} from './ExtraLoadingScreenConfig';

function ExtraLoadingScreen() {
  const theme = useTheme();
  const renderFooterLoading = () => {
    return (
      <Shimmer
        config={footerLoadingConfig(theme)}
        shimmerPlaceholderConfig={shimmerPlaceholderConfig}
      />
    );
  };
  const renderOptionsLoading = () => {
    return (
      <View style={styles.rowContainerStyle}>
        {[...Array(3).keys()].map(() => {
          return (
            <Shimmer
              config={optionsLoadingConfig(theme)}
              shimmerPlaceholderConfig={shimmerPlaceholderConfig}
            />
          );
        })}
      </View>
    );
  };
  const renderOptionTitleLoading = () => {
    return (
      <Shimmer
        config={optionTitleLoadingConfig}
        shimmerPlaceholderConfig={shimmerPlaceholderConfig}
      />
    );
  };
  const renderTitleLoading = () => {
    return (
      <Shimmer config={titleLoadingConfig} shimmerPlaceholderConfig={shimmerPlaceholderConfig} />
    );
  };
  const renderTabsLoading = () => {
    return (
      <View style={styles.rowContainerStyle}>
        {[...Array(2).keys()].map(() => {
          return (
            <Shimmer
              config={tabLoadingConfig(theme)}
              shimmerPlaceholderConfig={shimmerPlaceholderConfig}
            />
          );
        })}
      </View>
    );
  };

  return (
    <View style={styles.loadingContainerStyle}>
      {renderTitleLoading()}
      {renderTabsLoading()}
      {renderOptionTitleLoading()}
      {renderOptionsLoading()}
      {renderFooterLoading()}
    </View>
  );
}

export default ExtraLoadingScreen;
